// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__s4oll","left":"Virtual_left__B3OV6","wrapper":"Virtual_wrapper__VJ6uB"};